import type { PortfolioSummaryDto } from '../../shared/types';
import { compactMoney, type DisplayCurrency } from '../format';

const colors = ['#1f6b48', '#c8953d', '#315c78', '#90a196', '#775c93', '#d06d55'];

export function AllocationRing({ data, currency, usdThb }: {
  data: PortfolioSummaryDto['allocation']; currency: DisplayCurrency; usdThb: string;
}) {
  let cursor = 0;
  const stops = data.map((item, index) => {
    const start = cursor;
    cursor += item.percent;
    return `${colors[index % colors.length]} ${start}% ${cursor}%`;
  }).join(', ');
  const total = data.reduce((sum, item) => sum + Number(item.valueUsd), 0);
  return <div className="allocation-layout">
    <div className="donut" style={{ background: data.length ? `conic-gradient(${stops})` : '#e9edea' }}>
      <div className="donut-hole"><span>ทั้งหมด</span><strong>{data.length}</strong><small>ประเภท</small></div>
    </div>
    <div className="legend">
      {data.map((item, index) => <div className="legend-row" key={item.key}>
        <span className="legend-color" style={{ background: colors[index % colors.length] }} />
        <span className="legend-label">{item.label}</span>
        <span className="legend-value"><strong>{item.percent.toFixed(1)}%</strong><small>{compactMoney(item.valueUsd, currency, usdThb)}</small></span>
      </div>)}
      {!data.length && <p className="muted empty-small">ยังไม่มีสินทรัพย์</p>}
    </div>
    <span className="sr-only">มูลค่ารวม {total}</span>
  </div>;
}

export function PortfolioChart({ history, currency, usdThb }: {
  history: PortfolioSummaryDto['history']; currency: DisplayCurrency; usdThb: string;
}) {
  const fallback = history.length ? history : [
    { date: '', valueUsd: '0', contributionsUsd: '0' },
  ];
  const values = fallback.map((item) => Number(item.valueUsd));
  const min = Math.min(...values, 0);
  const max = Math.max(...values, 1);
  const points = fallback.map((item, index) => {
    const x = fallback.length === 1 ? 50 : (index / (fallback.length - 1)) * 100;
    const y = 86 - ((Number(item.valueUsd) - min) / (max - min || 1)) * 66;
    return `${x},${y}`;
  }).join(' ');
  const area = `0,100 ${points} 100,100`;
  const latest = fallback[fallback.length - 1];
  return <div className="portfolio-chart">
    <div className="chart-label"><span>มูลค่าล่าสุด</span><strong>{compactMoney(latest.valueUsd, currency, usdThb)}</strong></div>
    <svg viewBox="0 0 100 100" preserveAspectRatio="none" role="img" aria-label="กราฟมูลค่าพอร์ต">
      <defs><linearGradient id="area" x1="0" x2="0" y1="0" y2="1"><stop offset="0" stopColor="#1f6b48" stopOpacity=".24" /><stop offset="1" stopColor="#1f6b48" stopOpacity="0" /></linearGradient></defs>
      {[20, 42, 64, 86].map((y) => <line key={y} x1="0" x2="100" y1={y} y2={y} stroke="#dfe5e1" strokeWidth=".35" />)}
      <polygon points={area} fill="url(#area)" />
      <polyline points={points} fill="none" stroke="#1f6b48" strokeWidth="1.8" vectorEffect="non-scaling-stroke" />
    </svg>
    <div className="chart-axis"><span>{fallback[0]?.date || 'เริ่มต้น'}</span><span>{latest?.date || 'วันนี้'}</span></div>
  </div>;
}
